<template>
  <template v-if="geoWerftData.checkboxes.enable_filialen_mode">
    <div id="geowerft-list-wrapper" class="object-list">
      <ul class="list-area">
        <li v-if="!visible0bjects.length && loadingStatus">
          <p class="geoblink">
            Im ausgewählten Bereich sind keine Filialen vorhanden.
          </p>
        </li>
        <li v-if="!loadingStatus">
          <div v-if="geoWerftData.checkboxes.show_loading_icon">
            <div
              v-if="geoWerftData.custom_loading_icon !== ''"
              class="geowerft-loading-spinner-custom-wrapper"
            >
              <img
                alt=""
                loading="lazy"
                class="geowerft-custom-spinner-icon"
                v-bind:src="geoWerftData.custom_loading_icon"
              />
              <span class="geowerft-loading-spinner-text"
                >Filialen werden geladen ...</span
              >
            </div>
            <div v-else class="geowerft-loading-spinner">
              <i
                id="geowerft-spinner-ico-fil"
                class="fa fa-spinner fa-pulse fa-3x fa-fw"
              ></i>
              <span class="geowerft-loading-spinner-text"
                >Filialen werden geladen ...</span
              >
            </div>
          </div>
          <p v-else>Filialen werden geladen ...</p>
        </li>
        <li
          v-for="object in listedObjects"
          v-on:click="send_info_to_map(object.id)"
          v-bind:class="[
            'single-real-estate-agent',
            object.image_search_running ? 'loading-image' : '',
          ]"
          v-bind:id="object.id + '-list-click'"
        >
          <div class="mw-geo-real-estate-agent-wrapper">
            <div class="single-real-estate-agent-image">
              <img alt="" loading="lazy" :src="object.object_image_url" />
            </div>
            <div class="single-real-estate-agent-content">
              <div class="single-real-estate-agent-name">
                <h2 v-html="object.objekt_titel"></h2>
                <span v-html="object.ort"></span>
              </div>
              <div class="single-real-estate-agent-adress-contact-wrapper">
                <div class="single-real-estate-agent-adress">
                  <span v-html="object.strasse"></span>
                  <span v-html="object.plz"></span>
                </div>
                <div class="single-real-estate-agent-contact">
                  <span>
                    <i class="fa fa-phone" aria-hidden="true"></i>
                    {{ object.telefon }}
                  </span>
                  <a :href="'mailto:' + object.email">
                    <i class="fa fa-envelope" aria-hidden="true"></i> E-Mail
                    Kontakt
                  </a>
                </div>
              </div>
              <div class="single-real-estate-agent-url">
                <a
                  :href="object.link"
                  class="mw-filiale-link-left"
                  target="_blank"
                  v-html="geoWerftData.filialen_landingpage_label"
                ></a>
                <a
                  v-if="object.success_story"
                  class="mw-filiale-link-right"
                  :href="object.success_story"
                  target="_blank"
                  v-html="geoWerftData.filialen_success_story_label"
                ></a>
              </div>
            </div>
          </div>
        </li>
        <li v-if="visible0bjects.length > listedObjects.length">
          <p>
            Kartenauschnitt verkleinern um alle verfügbaren Filialen in dieser
            Liste darzustellen.
          </p>
        </li>
      </ul>
    </div>
  </template>

  <template v-else>
    <div
      id="geowerft-list-wrapper"
      v-bind:class="
        geoWerftData.checkboxes.user_has_searchwish
          ? 'object-list user-has-searchwish'
          : 'object-list'
      "
    >
      <div class="geowerft-lasche">
        <i class="fa fa-home" aria-hidden="true"></i>
      </div>
      <div class="geowerft-visible-immo-counter">
        {{ geoWerftData.objects.visible.length }} Objekte im
        Karten-Auschnitt.<br />
        {{ geoWerftData.objects.filtered.length }} von
        {{ geoWerftData.objects.all.length }} Objekte erfüllen die Filtern.
      </div>
      <ul
        class="list-area"
        onclick="localStorage.setItem( 'mw-last-visit-immoslider', window.location.href )"
      >
        <li
          class="mw-geowerft-special-info-text"
          v-if="'' !== this.geoWerftData.texts.text_sc_info_text"
        >
          <p v-html="this.geoWerftData.texts.text_sc_info_text"></p>
        </li>
        <li
          class="mw-blacklist-config-wrapper"
          v-if="true === this.current_user_can_see_blacklist()"
        >
          <div class="mw-toggle-blacklist-config">
            <p>Ausgeschlossene Immobilien:</p>
            <a
              href=""
              class="avia-button mw-toggle-blacklist-on"
              aria-label="Ausgeschlossene Immobilien ausblenden"
              >Ausblenden</a
            >
            <a
              href=""
              class="avia-button mw-toggle-blacklist-off"
              aria-label="Ausgeschlossene Immobilien anzeigen"
              >Anzeigen</a
            >
          </div>
        </li>
        <li
          class="mw-additional-content-li-wrapper"
          v-if="
            true ===
            geoWerftData.additional_content.geowerft_additional_info_box
          "
        >
          <div
            class="geowerft_additonal_content_wrapper"
            v-html="
              geoWerftData.additional_content
                .geowerft_additional_info_box_template
            "
          ></div>
        </li>
        <li
          v-if="
            geoWerftData.checkboxes.secret_bar_active &&
            !geoWerftData.user.logged_in
          "
        >
          <div class="geowerft-sneak-peak-wrapper">
            <div class="geowerft-sneak-peak-ico-wrapper">
              <i
                class="fa fa-bell geowerft-sneak-peak-bell-icon"
                aria-hidden="true"
              ></i>
            </div>
            <div class="geowerft-sneak-peak-border"></div>
            <div class="geowerft-sneak-peak-content">
              {{ geoWerftData.secret_bar_max_count }}
              {{ geoWerftData.texts.secret_sale_headline }}
            </div>
            <div class="geowerft-sneak-peak-sub-head">
              {{ geoWerftData.texts.secret_sale_sub_text }}
            </div>
            <div class="geowerft-sneak-peak-register-wrap">
              <a
                v-bind:href="geoWerftData.texts.secret_bar_register_link"
                target="_blank"
                >{{ geoWerftData.texts.secret_sale_button }}</a
              >
            </div>
          </div>
        </li>
        <li v-if="!visible0bjects.length && loadingStatus">
          <p
            class="geoblink"
            v-html="
              return_no_immo_in_b_text(this.geoWerftData.current_map_mode)
            "
          ></p>
        </li>
        <li
          v-if="
            true === geoWerftData.geowerft_immo_loading &&
            'map' === this.geoWerftData.current_map_mode
          "
        >
          <div v-if="geoWerftData.checkboxes.show_loading_icon">
            <div
              v-if="geoWerftData.custom_loading_icon !== ''"
              class="geowerft-loading-spinner-custom-wrapper"
            >
              <img
                alt=""
                loading="lazy"
                class="geowerft-custom-spinner-icon"
                v-bind:src="geoWerftData.custom_loading_icon"
              />
              <span
                class="geowerft-loading-spinner-text"
                v-html="geoWerftData.texts.prop_loading_text"
              ></span>
            </div>
            <div v-else class="geowerft-loading-spinner">
              <i
                id="geowerft-spinner-ico"
                class="fa fa-spinner fa-pulse fa-3x fa-fw"
              ></i>
              <span
                class="geowerft-loading-spinner-text"
                v-html="geoWerftData.texts.prop_loading_text"
              ></span>
            </div>
          </div>
          <p v-else v-html="geoWerftData.texts.prop_loading_text"></p>
        </li>
        <li
          v-for="(object, index) in listedObjects"
          v-bind:title="get_the_title(object)"
          v-bind:class="[
            'single-object',
            object.image_search_running ? 'loading-image' : '',
            sanitize_title_method(object.homepage_status),
            sanitize_title_method(object.vermarktungsart),
            geoWerftData.checkboxes.display_picture_max_width_or_height
              ? 'mw-prop-pricture-max-width'
              : 'mw-prop-pricture-max-height',
            object.vermarktungsart &&
            object.vermarktungsart.toLowerCase() ===
              geoWerftData.texts.blur_hp_status_name.toLowerCase() &&
            geoWerftData.checkboxes.display_marketing_method === true
              ? 'mw-display-fremdobjekt-li'
              : '',
          ]"
          v-bind:data-index="index"
          v-bind:data-id="object.id"
        >
          <div
            v-if="geoWerftData.texts.list_visibility_json"
            v-html="mw_list_get_settings_by_json(object)"
          ></div>
          <div v-bind="trigger_banner_render(index)"></div>
          <div
            title="Immobilie merken"
            v-on:click="
              trigger_mw_watchlist(
                object.id,
                $event,
                geoWerftData.user.current_user_id
              )
            "
            v-if="
              true === current_user_can_see_watchlist_icons(object) &&
              '' === geoWerftData.geowerft_setting_watchlist_icon_custom
            "
            :class="'mw-watchlist-remember-immo'"
            :data-mw-prop-kennung="object.id"
          >
            <div>
              <em
                v-bind:class="check_current_watchlist_status(object.id)"
                :id="'watch-class-' + object.id"
                aria-hidden="true"
              ></em>
            </div>
          </div>

          <div
            v-bind:title="get_new_watchlist_titel(object.id)"
            v-on:click="
              trigger_mw_watchlist_new(
                object.id,
                $event,
                geoWerftData.user.current_user_id
              )
            "
            v-if="
              true === current_user_can_see_watchlist_icons(object) &&
              '' !== geoWerftData.geowerft_setting_watchlist_icon_custom
            "
            :class="'mw-watchlist-remember-immo'"
            :data-mw-prop-kennung="object.id"
          >
            <div
              v-if="'' !== geoWerftData.geowerft_setting_watchlist_icon_custom"
              v-bind:class="check_current_watchlist_status(object.id)"
              :id="'watch-class-' + object.id"
              v-html="get_new_watchlist_icon(object.id)"
            ></div>
          </div>

          <div
            v-on:click="
              trigger_mw_blacklist(
                object.id,
                $event,
                geoWerftData.user.current_user_id
              )
            "
            v-if="true === current_user_can_see_blacklist()"
            :class="'mw-blacklist-immo'"
            :data-mw-prop-kennung="object.id"
          >
            <div
              v-bind:title="check_current_blacklist_status_title(object.id)"
              v-html="geoWerftData.user_blacklist_icon"
              v-bind:class="check_current_blacklist_status(object.id)"
              :id="'mw-blacklist-id-' + object.id"
              aria-hidden="true"
            ></div>
          </div>

          <div
            v-on:click="mw_gtb_open_login_or_register()"
            v-else-if="true === current_user_can_see_offline_blacklist()"
            :class="'mw-blacklist-immo'"
            :data-mw-prop-kennung="object.id"
          >
            <div
              v-bind:title="check_current_blacklist_status_title(object.id)"
              v-html="geoWerftData.user_blacklist_icon"
              class="mw-blacklist-icon-wrapper mw-offline-blacklist"
              :id="'mw-blacklist-id-' + object.id"
              aria-hidden="true"
            ></div>
          </div>

          <div
            class="mw-watchlist-gtb-offline"
            v-if="true === mw_display_gtb_watchlist()"
            v-on:click="mw_gtb_open_login_or_register()"
            title="Immobilie merken"
          >
            <em
              v-if="'' === geoWerftData.geowerft_setting_watchlist_icon_custom"
              class="fa fa-heart-o fa-2x"
            ></em>
            <div
              v-if="'' !== geoWerftData.geowerft_setting_watchlist_icon_custom"
              v-bind:class="check_current_watchlist_status(object.id)"
              :id="'watch-class-' + object.id"
              v-html="geoWerftData.geowerft_setting_watchlist_icon_custom"
            ></div>
          </div>

          <!--Detailed Watchlist-->
          <div
            v-if="true === mw_display_gtb_watchlist_detailed()"
            v-on:click="
              trigger_mw_watchlist_detailed(
                object.id,
                $event,
                geoWerftData.user.current_user_id
              )
            "
            v-html="get_watchlist_detailed_current_icon(object.id)"
            v-bind:class="check_current_watchlist_detailed_status(object.id)"
            :data-mw-prop-kennung="object.id"
          ></div>
          <!--Detailed Watchlist Ende-->

          <div
            v-bind:class="
              'mw-geo-set-prop-offline-list ' +
              get_active_watchlist_class(object)
            "
            v-if="
              (true === geoWerftData.checkboxes.allow_prop_offline_detection &&
                ((true ===
                  geoWerftData.checkboxes
                    .allow_prop_offline_detection_only_logged_in &&
                  geoWerftData.user.logged_in) ||
                  false ===
                    geoWerftData.checkboxes
                      .allow_prop_offline_detection_only_logged_in) &&
                object.homepage_status &&
                object.homepage_status.toLowerCase() ===
                  geoWerftData.texts.prop_offline_hp_status.toLowerCase()) ||
              (object.vermarktungsart &&
                object.vermarktungsart.toLowerCase() ===
                  geoWerftData.texts.prop_offline_hp_status.toLowerCase())
            "
            @click="set_selected_prop_offline($event.target, 'li')"
          >
            <div
              title="Dieses Angebot ist nicht mehr verfügbar?"
              class="mw-set-prop-offline-content"
            >
              <img
                alt=""
                v-bind:src="geoWerftData.texts.prop_offline_picture"
              />
            </div>
          </div>

          <img
            v-if="true === geoWerftData.use_img_tag_in_list"
            v-bind:src="
              get_picture_url(
                object.object_image_url,
                geoWerftData.image_placeholder_empty,
                object.map_picture,
                object.homepage_status,
                object.objektart_raw
              )
            "
            v-bind:alt="set_alt_tag(object)"
            loading="lazy"
            width="100%"
            height="230px"
            class="mw-geowerft-list-single-prop-img mw-geowerft-bg-image"
            @click="handle_picture_click(object, $event)"
          />

          <div
            v-if="false === geoWerftData.use_img_tag_in_list"
            class="mw-geowerft-bg-image"
            @click="handle_picture_click(object, $event)"
            v-bind:style="
              get_picture_url(
                object.object_image_url,
                geoWerftData.image_placeholder_empty,
                object.map_picture,
                object.homepage_status,
                object.objektart_raw
              )
            "
          ></div>

          <div
            v-if="
              ('ja' === (object.ogulo_tour || '') ||
                '1' === (object.ogulo_tour || '')) &&
              geoWerftData.checkboxes.display_tour_icon
            "
            class="mw-list-tour-icon-wrapper"
          >
            <div class="tour-ico-wrapper">
              <img
                alt=""
                v-if="'' !== geoWerftData.customimages.tour_icon_src"
                v-bind:src="geoWerftData.customimages.tour_icon_src"
              />
            </div>
          </div>

          <div
            v-if="
              geoWerftData.current_map_mode === 'map' &&
              object.vermarktungsart &&
              'zukunftsmarktradar' === object.vermarktungsart.toLowerCase()
            "
            class="mw-geo-future-extra-info"
            v-html="get_future_extra_fields(object)"
          ></div>

          <span
            v-if="
              (object.homepage_status === 'Aktive Marktbeobachtung' ||
                object.vermarktungsart === 'Fremdobjekt') &&
              object.link_extern === '' &&
              false === geoWerftData.checkboxes.custom_marketwatch_temp_active
            "
          ></span>
          <a
            v-else-if="
              (object.homepage_status === 'Aktive Marktbeobachtung' ||
                object.vermarktungsart === 'Fremdobjekt') &&
              true === geoWerftData.checkboxes.logged_in_market_watch &&
              false === geoWerftData.user.logged_in
            "
            :href="geoWerftData.texts.market_watch_alt_link"
            target="_blank"
            ><h2 class="object-titel" v-html="object.objekttitel"></h2
          ></a>
          <a
            v-else-if="
              (object.homepage_status === 'Aktive Marktbeobachtung' ||
                object.vermarktungsart === 'Fremdobjekt') &&
              false === geoWerftData.checkboxes.custom_marketwatch_temp_active
            "
            :href="object.link_extern"
            target="_blank"
            ><h2
              class="object-titel"
              v-html="get_special_list_title(object)"
            ></h2
          ></a>
          <a
            v-else-if="
              true === geoWerftData.show_extern_link &&
              object.link_extern &&
              object.link_extern !== '' &&
              false === geoWerftData.checkboxes.custom_marketwatch_temp_active
            "
            class="btn-details"
            :href="object.link_extern"
            target="_blank"
            ><h2 class="object-titel" v-html="object.objekttitel"></h2
          ></a>
          <a
            v-else-if="geoWerftData.checkboxes.other_info_window"
            :href="object.link"
            target="_blank"
          >
            <h2
              class="object-titel"
              v-html="
                object.plz + ' ' + object.ort + ' | ' + object.objektart_raw
              "
            ></h2
          ></a>
          <a
            v-else
            class="geowerft-list-anker"
            :href="object.link"
            target="_blank"
            ><h2
              class="object-titel"
              v-html="get_special_list_title(object)"
            ></h2
          ></a>
          <span
            class="object-display-special-banner"
            v-if="object.mw_display_vermarktungsart"
            >{{ object.mw_display_vermarktungsart }}</span
          >
          <p
            v-if="geoWerftData.checkboxes.other_info_window"
            class="object-place"
            v-html="'Objekt Nr.: ' + object.kennung"
          ></p>
          <p v-else class="object-place">
            <span
              class="geo-plz-list"
              v-if="
                object.vermarktungsart &&
                'zukunftsmarktradar' === object.vermarktungsart.toLowerCase()
              "
              v-html="object.plz + ' '"
            ></span>
            <span
              class="geo-kennung-list"
              v-if="
                true === geoWerftData.checkboxes.display_kennung_in_object_place
              "
              v-html="object.kennung + ' | '"
            ></span>
            <span
              class="geo-plz-list"
              v-if="
                true === geoWerftData.checkboxes.display_plz_in_object_place &&
                false === geoWerftData.checkboxes.other_info_window_v2
              "
              v-html="object.plz + ' '"
            ></span>
            <span
              class="city"
              v-if="
                false === geoWerftData.checkboxes.set_geolocation &&
                false === geoWerftData.checkboxes.other_info_window_v2
              "
              v-html="handle_place_view(object)"
            ></span>
            <span
              class="mw-geo-geolage"
              v-if="
                true === geoWerftData.checkboxes.set_geolocation &&
                object.geolage
              "
              v-html="object.geolage + ' | '"
            ></span>
            <span
              v-if="false === geoWerftData.checkboxes.other_info_window_v2"
              class="type"
              v-html="get_the_correct_type(object)"
            ></span>
            <span
              class="source-external-link"
              v-if="
                object.homepage_status === 'Aktive Marktbeobachtung' ||
                object.vermarktungsart === 'Fremdobjekt' ||
                (geoWerftData.checkboxes.display_sorce_in_market_watch &&
                  object.vermarktungsart &&
                  object.vermarktungsart.toLowerCase() ===
                    geoWerftData.texts.market_watch_name.toLowerCase())
              "
            >
              Quelle:
              <span
                v-if="object.link_extern !== ''"
                v-html="get_link_extern(object)"
              ></span>
              <span v-else v-html="object.kennung"></span>
            </span>
            <span
              v-if="
                true === geoWerftData.checkboxes.other_info_window_v2 &&
                object.vermarktungsart !== 'Fremdobjekt'
              "
            >
              Quelle:
              <span v-html="geoWerftData.texts.prop_own_source_text"></span>
            </span>
          </p>

          <!--Spezielle JSON Config-->
          <div
            class="mw-config-special-list-fields"
            v-if="geoWerftData.list_view_config"
          >
            <div
              class="mw-config-special-list-fields-single-wrapper"
              v-for="(arr_setting, index, count) in geoWerftData
                .list_view_config.fields"
              v-html="get_special_list_conf_html(arr_setting, object)"
            ></div>
          </div>
          <!--Spezielle JSON Config Ende-->

          <!--
            Wenn die erweiterte Listenansicht aktiviert ist, werden weitere Icons und werte eingefügt.
          -->
          <span
            v-bind:class="
              'geowerft-list-values-wrapper-whole' +
              ' ' +
              replaceUmlauts(object.objektart_raw)
            "
            v-if="
              true === geoWerftData.checkboxes.show_more_info_in_list ||
              (geoWerftData.checkboxes.list_map_switcher &&
                geoWerftData.checkboxes.advanced_list_view &&
                'list' === geoWerftData.current_map_mode)
            "
          >
            <span class="geowerft-list-values-wrapper">
              <span
                v-if="object.anzahl_zimmer && object.anzahl_zimmer !== '0'"
                class="geowerft-list-values-single-row zimmer"
              >
                <span
                  class="geowerft-list-icon-wrapper geowerft-list-svg-rooms"
                >
                  <svg viewBox="0 0 22 24">
                    <path
                      d="M10,8H0V0H10ZM22,0H12V8H22ZM10,10H0V24H10Zm12,0H12V24H22Z"
                      transform="translate(0 0)"
                    />
                  </svg>
                </span>
                <span class="geowerft-list-value-text">Zimmer</span>
                <span
                  v-html="mw_format_list_number_output(object.anzahl_zimmer)"
                  class="geowerft-list-value"
                ></span>
              </span>
              <span
                v-if="object.baujahr && object.baujahr !== '0'"
                class="geowerft-list-values-single-row baujahr"
              >
                <span
                  class="geowerft-list-icon-wrapper geowerft-list-svg-build"
                >
                  <svg viewBox="0 0 1024 1024">
                    <path
                      d="M192 576l64 384h192V640h128v320h192l64-384L512 256 192 576zM832 384V128H704l0.312 128.312L512 64 0 576h128l384-384 384 384h128L832 384z"
                    />
                    ';
                  </svg>
                </span>
                <span class="geowerft-list-value-text">Baujahr</span>
                <span
                  v-html="object.baujahr"
                  class="geowerft-list-value"
                ></span>
              </span>
              <span
                v-if="
                  object.objektart_raw &&
                  object.wohnflaeche &&
                  -1 === object.objektart_raw.toLowerCase().indexOf('invest')
                "
                class="geowerft-list-values-single-row wohnflaeche"
              >
                <span
                  class="geowerft-list-icon-wrapper geowerft-list-svg-fleache"
                >
                  <svg class="stroke" viewBox="0 0 23 23">
                    <path
                      d="M23.48,23.48h-16v-16h16ZM8.48,3V7m3-6V7m3-4V7m3-6V7m3-4V7m3-6V7M3,8.48H7m-6,3H7m-4,3H7m-6,3H7m-4,3H7m-6,3H7"
                      transform="translate(-0.98 -0.98)"
                    />
                  </svg>
                </span>
                <span class="geowerft-list-value-text">Wohnfläche</span>
                <span
                  v-html="'ca. ' + mw_format_area(object.wohnflaeche) + ' m²'"
                  class="geowerft-list-value"
                ></span>
              </span>
              <span
                v-if="
                  (object.gesamtflaeche &&
                    true === geoWerftData.geo_business_mode &&
                    false === geoWerftData.geo_business_mode_bueroflaeche) ||
                  (object.gesamtflaeche &&
                    true === geoWerftData.checkboxes.display_ges_flaeche)
                "
                class="geowerft-list-values-single-row gesamtflaeche"
              >
                <span
                  class="geowerft-list-icon-wrapper geowerft-list-svg-fleache"
                >
                  <svg class="stroke" viewBox="0 0 23 23">
                    <path
                      d="M23.48,23.48h-16v-16h16ZM8.48,3V7m3-6V7m3-4V7m3-6V7m3-4V7m3-6V7M3,8.48H7m-6,3H7m-4,3H7m-6,3H7m-4,3H7m-6,3H7"
                      transform="translate(-0.98 -0.98)"
                    />
                  </svg>
                </span>
                <span
                  class="geowerft-list-value-text"
                  v-html="geoWerftData.texts.label_flaeche_list_view"
                ></span>
                <span
                  v-html="'ca. ' + mw_format_area(object.gesamtflaeche) + ' m²'"
                  class="geowerft-list-value"
                ></span>
              </span>
              <span
                v-if="
                  object.anzahl_wohneinheiten &&
                  true === geoWerftData.show_einheiten_in_list
                "
                class="geowerft-list-values-single-row anzahl_wohneinheiten"
              >
                <span
                  class="geowerft-list-icon-wrapper geowerft-list-svg-rooms"
                >
                  <svg viewBox="0 0 22 24">
                    <path
                      d="M10,8H0V0H10ZM22,0H12V8H22ZM10,10H0V24H10Zm12,0H12V24H22Z"
                      transform="translate(0 0)"
                    />
                  </svg>
                </span>
                <span class="geowerft-list-value-text">Einheiten</span>
                <span
                  v-html="
                    mw_format_list_number_output(object.anzahl_wohneinheiten)
                  "
                  class="geowerft-list-value"
                ></span>
              </span>
              <span
                v-if="
                  object.bueroflaeche &&
                  true === geoWerftData.geo_business_mode &&
                  true === geoWerftData.geo_business_mode_bueroflaeche
                "
                class="geowerft-list-values-single-row bueroflaeche"
              >
                <span
                  class="geowerft-list-icon-wrapper geowerft-list-svg-fleache"
                >
                  <svg class="stroke" viewBox="0 0 23 23">
                    <path
                      d="M23.48,23.48h-16v-16h16ZM8.48,3V7m3-6V7m3-4V7m3-6V7m3-4V7m3-6V7M3,8.48H7m-6,3H7m-4,3H7m-6,3H7m-4,3H7m-6,3H7"
                      transform="translate(-0.98 -0.98)"
                    />
                  </svg>
                </span>
                <span
                  class="geowerft-list-value-text"
                  v-html="geoWerftData.texts.label_flaeche_list_view"
                ></span>
                <span
                  v-html="'ca. ' + mw_format_area(object.bueroflaeche) + ' m²'"
                  class="geowerft-list-value"
                ></span>
              </span>
              <span
                v-if="
                  object.teilbar_ab && true === geoWerftData.geo_business_mode
                "
                class="geowerft-list-values-single-row teilbarkeit"
              >
                <span
                  class="geowerft-list-icon-wrapper geowerft-list-svg-fleache"
                >
                  <svg class="teilbarkeit-ab" viewBox="0 0 22 24">
                    <path
                      d="M10,8H0V0H10ZM22,0H12V8H22ZM10,10H0V24H10Zm12,0H12V24H22Z"
                      transform="translate(0 0)"
                    ></path>
                  </svg>
                </span>
                <span class="geowerft-list-value-text">Teilbarkeit ab</span>
                <span
                  v-html="'ca. ' + mw_format_area(object.teilbar_ab) + ' m²'"
                  class="geowerft-list-value"
                ></span>
              </span>
              <span
                v-if="
                  object.objektart_raw &&
                  object.vermietbare_flaeche &&
                  -1 !== object.objektart_raw.toLowerCase().indexOf('invest')
                "
                class="geowerft-list-values-single-row vermietbarefl"
              >
                <span
                  class="geowerft-list-icon-wrapper geowerft-list-svg-fleache"
                >
                  <svg class="stroke" viewBox="0 0 23 23">
                    <path
                      d="M23.48,23.48h-16v-16h16ZM8.48,3V7m3-6V7m3-4V7m3-6V7m3-4V7m3-6V7M3,8.48H7m-6,3H7m-4,3H7m-6,3H7m-4,3H7m-6,3H7"
                      transform="translate(-0.98 -0.98)"
                    />
                  </svg>
                </span>
                <span class="geowerft-list-value-text">Vermietbare Fläche</span>
                <span
                  v-html="
                    'ca. ' + mw_format_area(object.vermietbare_flaeche) + ' m²'
                  "
                  class="geowerft-list-value"
                ></span>
              </span>
              <span
                v-if="
                  (true ===
                    geoWerftData.checkboxes.show_ground_fl_for_house_in_list &&
                    object.objektart_raw &&
                    object.grundstuecksflaeche &&
                    -1 !==
                      object.objektart_raw.toLowerCase().indexOf('haus')) ||
                  (object.objektart_raw &&
                    object.grundstuecksflaeche &&
                    -1 !== object.objektart_raw.toLowerCase().indexOf('grund'))
                "
                class="geowerft-list-values-single-row grundstuecksfl"
              >
                <span
                  class="geowerft-list-icon-wrapper geowerft-list-svg-fleache"
                >
                  <svg class="stroke" viewBox="0 0 23 23">
                    <path
                      d="M23.48,23.48h-16v-16h16ZM8.48,3V7m3-6V7m3-4V7m3-6V7m3-4V7m3-6V7M3,8.48H7m-6,3H7m-4,3H7m-6,3H7m-4,3H7m-6,3H7"
                      transform="translate(-0.98 -0.98)"
                    />
                  </svg>
                </span>
                <span class="geowerft-list-value-text">Grundstücksfläche</span>
                <span
                  v-html="
                    'ca. ' + mw_format_area(object.grundstuecksflaeche) + ' m²'
                  "
                  class="geowerft-list-value"
                ></span>
              </span>
              <span
                v-if="
                  true === geoWerftData.checkboxes.show_nutzflaeche_in_list &&
                  object.nutzflaeche
                "
                class="geowerft-list-values-single-row nutzflaeche"
              >
                <span
                  class="geowerft-list-icon-wrapper geowerft-list-svg-fleache"
                >
                  <svg class="stroke" viewBox="0 0 23 23">
                    <path
                      d="M23.48,23.48h-16v-16h16ZM8.48,3V7m3-6V7m3-4V7m3-6V7m3-4V7m3-6V7M3,8.48H7m-6,3H7m-4,3H7m-6,3H7m-4,3H7m-6,3H7"
                      transform="translate(-0.98 -0.98)"
                    />
                  </svg>
                </span>
                <span class="geowerft-list-value-text">Nutzfläche</span>
                <span
                  v-html="'ca. ' + mw_format_area(object.nutzflaeche) + ' m²'"
                  class="geowerft-list-value"
                ></span>
              </span>
              <span
                v-if="
                  ('ja' === (object.ogulo_tour || '') ||
                    '1' === (object.ogulo_tour || '')) &&
                  geoWerftData.checkboxes.display_tour_icon
                "
                class="mw-list-tour-icon-wrapper-side-icon"
              >
                <div class="tour-ico-wrapper-side-icon">
                  <img
                    alt=""
                    v-if="'' !== geoWerftData.customimages.tour_icon_src"
                    v-bind:src="geoWerftData.customimages.tour_icon_src"
                  />
                </div>
              </span>
            </span>
            <span
              class="object-pricing-no-commission"
              v-if="true === check_commision(object)"
            >
              {{ geoWerftData.texts.display_text_no_buyer_comission }}
            </span>
          </span>
          <!-- Ende -->
          <span
            class="geowerft-sold-banner type-sold"
            v-if="
              true === geoWerftData.show_sold_banner &&
              object.homepage_status &&
              ('verkauft' === object.homepage_status.toLowerCase() ||
                'vermarktet' === object.homepage_status.toLowerCase() ||
                object.homepage_status.toLowerCase().indexOf('referenz') >= 0)
            "
          >
            <span
              v-if="
                object.erwerbsart &&
                (object.erwerbsart.toLowerCase() === 'kauf' ||
                  object.erwerbsart.toLowerCase() === 'buy')
              "
              class="geowerft-sold-banner-inner"
              v-html="map_get_sold_label(object)"
            ></span>
            <span
              v-else-if="
                object.erwerbsart &&
                (object.erwerbsart.toLowerCase() === 'miete' ||
                  object.erwerbsart.toLowerCase() === 'rent')
              "
              class="geowerft-sold-banner-inner"
              >Vermietet</span
            >
          </span>
          <span
            v-else-if="
              (object.reservierung_ende !== undefined &&
                object.reservierung_ende !== '' &&
                Date.parse(parseDate(object.reservierung_ende)) >=
                  Date.now()) ||
              (object.reservierung_begin !== undefined &&
                object.reservierung_begin !== '' &&
                (object.reservierung_ende === undefined ||
                  object.reservierung_ende === '') &&
                Date.parse(parseDate(object.reservierung_begin)) <= Date.now())
            "
            class="geowerft-sold-banner reserved-status"
          >
            Reserviert
          </span>
          <span
            v-else-if="
              object.homepage_status &&
              true === geoWerftData.checkboxes.show_in_prep_banner &&
              'in vorbereitung' === object.homepage_status.toLowerCase()
            "
            class="geowerft-sold-banner prep-status"
          >
            In Vorbereitung
          </span>
          <span
            v-else-if="object.display_badge_new"
            class="geowerft-sold-banner prep-status"
          >
            <span class="new-prop-badge">NEU</span>
            <span
              class="new-prop-price"
              v-html="render_new_badge_content(object)"
            ></span>
          </span>
          <span
            v-else-if="
              object.homepage_status &&
              'bieterverfahren' === object.homepage_status.toLowerCase()
            "
            v-html="geoWerftData.auction_list_label"
            class="geowerft-sold-banner auction"
          ></span>
          <span
            v-else-if="
              object.erwerbsart &&
              (object.erwerbsart.toLowerCase() === 'miete' ||
                object.erwerbsart.toLowerCase() === 'rent') &&
              isNaN(parseInt(object.nettokaltmiete)) &&
              undefined !== object.nettokaltmiete &&
              '' !== object.nettokaltmiete
            "
            v-bind:class="[
              'geowerft-rent-banner',
              'status-' + object.homepage_status,
              'vermarktungsart-' + object.vermarktungsart,
              (object.nettokaltmiete || '')
                .trim()
                .toLowerCase()
                .replace(/\s/g, ''),
            ]"
          >
            {{ object.nettokaltmiete }}
          </span>
          <span
            v-else-if="
              object.erwerbsart &&
              (object.erwerbsart.toLowerCase() === 'kauf' ||
                object.erwerbsart.toLowerCase() === 'buy') &&
              isNaN(parseInt(object.kaufpreis)) &&
              undefined !== object.kaufpreis &&
              '' !== object.kaufpreis
            "
            v-bind:class="[
              'geowerft-sold-banner',
              'status-' + object.homepage_status,
              'vermarktungsart-' + object.vermarktungsart,
              (object.kaufpreis || '').trim().toLowerCase().replace(/\s/g, ''),
            ]"
          >
            {{ object.kaufpreis }}
          </span>
          <p
            v-else-if="
              (!isNaN(parseInt(mabye_get_on_request_price(object))) &&
                object.homepage_status &&
                'in vorbereitung' !== object.homepage_status.toLowerCase()) ||
              (!isNaN(parseInt(mabye_get_on_request_price(object))) &&
                object.homepage_status &&
                'in vorbereitung' === object.homepage_status.toLowerCase() &&
                true === geoWerftData.checkboxes.display_prep_price)
            "
            class="object-pricing"
          >
            <span>{{ geoWerftData.texts.display_text_price_purchase }}</span>
            <span
              class="extra-no-comission-info-wrapper"
              v-if="
                true === geoWerftData.checkboxes.display_extra_commision_info &&
                true === check_commision(object)
              "
            >
              <span class="extra-no-comission-info">{{
                geoWerftData.texts.display_text_no_buyer_comission
              }}</span>
            </span>
            {{ get_format_price(object.kaufpreis, object) }}
            {{ get_suffix_special(object) }}
          </p>
          <p
            v-else-if="
              (!isNaN(parseInt(object.nettokaltmiete)) &&
                object.homepage_status &&
                'in vorbereitung' !== object.homepage_status.toLowerCase()) ||
              (!isNaN(parseInt(object.nettokaltmiete)) &&
                object.homepage_status &&
                'in vorbereitung' === object.homepage_status.toLowerCase() &&
                true === geoWerftData.checkboxes.display_prep_price)
            "
            class="object-pricing"
          >
            <span>{{ geoWerftData.texts.display_text_price_rent }}</span>
            {{
              geoWerftData.checkboxes.show_warmmiete
                ? get_format_price(object.warmmiete, object)
                : get_format_price(object.nettokaltmiete, object)
            }}
            {{ geoWerftData.texts.currency_suffix }}
          </p>
          <p
            v-else-if="
              (!isNaN(parseInt(object.mietpreis_pro_qm)) &&
                object.homepage_status &&
                'in vorbereitung' !== object.homepage_status.toLowerCase()) ||
              (!isNaN(parseInt(object.mietpreis_pro_qm)) &&
                object.homepage_status &&
                'in vorbereitung' === object.homepage_status.toLowerCase() &&
                true === geoWerftData.checkboxes.display_prep_price)
            "
            class="object-pricing"
          >
            <span>{{ geoWerftData.texts.mietpreis_pro_qm_pre }}</span>
            {{ get_format_price(object.mietpreis_pro_qm, object) }}
            {{ geoWerftData.texts.mietpreis_pro_qm_post }}
          </p>
          <p
            v-else-if="
              true === geoWerftData.checkboxes.other_info_window_v2 &&
              object.erwerbsart &&
              (object.erwerbsart.toLowerCase() === 'kauf' ||
                object.erwerbsart.toLowerCase() === 'buy') &&
              (object.vermarktungsart || '').toLowerCase() === 'fremdobjekt' &&
              '' === (object.kaufpreis || '')
            "
            class="object-pricing no-price"
          >
            <span>{{ geoWerftData.texts.display_text_price_purchase }}</span>
            <span class="no-price-text">ohne Preisangabe</span>
          </p>
          <div
            class="extra-fremdobject-banderole-outer-wrapper"
            v-if="
              true === geoWerftData.checkboxes.other_info_window_v2 &&
              (object.vermarktungsart || '').toLowerCase() === 'fremdobjekt' &&
              '' !== geoWerftData.texts.display_extra_banderole
            "
            v-html="geoWerftData.texts.display_extra_banderole"
          ></div>
          <span
            class="in-prep-price-wrapper"
            v-else-if="
              true === geoWerftData.checkboxes.other_info_window_v2 &&
              (object.vermarktungsart || '').toLowerCase() !== 'fremdobjekt' &&
              'in vorbereitung' === object.homepage_status.toLowerCase() &&
              false === geoWerftData.checkboxes.display_prep_price
            "
          >
            <span class="in-prep-price-label">{{
              geoWerftData.texts.display_text_price_purchase
            }}</span>
            <span class="in-prep-price-value">in Vorbereitung</span>
          </span>
          <span class="object-pricing-marktwert" v-if="object.mw_marktwert"
            ><span>Marktwert</span>
            {{ get_format_price(object.mw_marktwert, object) }}
            {{ geoWerftData.texts.currency_suffix }}</span
          >
          <span
            class="geowerft-prov-free-banner"
            v-if="
              true === geoWerftData.show_prov_free_banner &&
              'nein' === (object.aussencourtage_ja || 'ja').toLowerCase() &&
              'kauf' ===
                (object.erwerbsart || '').toLowerCase().replace('buy', 'kauf')
            "
          >
            Provisionsfrei
          </span>
          <span
            v-bind:class="
              'geowerft-pin-wrapper' +
              ' ' +
              sanitize_title_method(object.homepage_status)
            "
            v-if="
              geoWerftData.checkboxes.display_custom_pin_in_list === true &&
              loadingStatus
            "
          >
            <span>
              <img
                v-if="
                  object.map_pin === '' || typeof object.map_pin === 'undefined'
                "
                v-on:click="send_info_to_map(object.id)"
                loading="lazy"
                class="geowerft-custom-marker"
                v-bind:src="
                  get_customizer_image_for_marker(
                    object.homepage_status,
                    object.display_badge_new
                  )
                "
                alt=""
              />
              <img
                v-else
                v-on:click="send_info_to_map(object.id)"
                class="geowerft-custom-marker"
                v-bind:src="object.map_pin"
                loading="lazy"
                alt=""
              />
            </span>
          </span>

          <span v-else>
            <p class="object-center-pin">
              <span>
                <i
                  v-on:click="send_info_to_map(object.id)"
                  class="fa fa-map-marker"
                  aria-hidden="true"
                ></i>
              </span>
            </p>
          </span>
        </li>

        <li
          class="mw-geowerft-not-in-scope"
          v-if="visible0bjects.length > listedObjects.length"
        >
          <p v-html="this.geoWerftData.texts.not_in_scope_text"></p>
        </li>
        <li
          v-if="
            false === this.geoWerftData.geowerft_immo_loading &&
            0 === this.geoWerftData.objects.all.length
          "
          class="geowerft-no-immo-in-route"
          v-html="this.geoWerftData.no_prop_in_route_text"
        ></li>
        <li v-if="true === this.geoWerftData.geowerft_no_props_from_route">
          Zurzeit können keine Immobilien angezeigt werden. Bitte versuchen Sie
          es später noch einmal.
        </li>
      </ul>
    </div>
  </template>
</template>

<script>
import EventBus from "../data/eventbus.js";
export default {
  data() {
    return {};
  },
  props: ["geoWerftData"],
  computed: {
    filteredObjects: function () {
      return this.geoWerftData.objects.filtered;
    },
    visible0bjects: function () {
      return this.geoWerftData.objects.visible;
    },
    listedObjects: function () {
      return this.geoWerftData.objects.listed;
    },
    loadingStatus() {
      // Return the length of the objects array
      return this.geoWerftData.objects.all.length;
    },
  },
  methods: {
    get_special_list_conf_html(arr_current_config, current_prop) {
      const current_key = arr_current_config.key || "";
      if (current_prop[current_key]) {
        let output_value = current_prop[current_key];
        // Hier noch eine Formattierung einbauen.
        if ("currency" === arr_current_config.format) {
          output_value =
            this.get_format_price(output_value, current_prop) + " €";
        }
        if ("area" === arr_current_config.format) {
          output_value = this.mw_format_area(output_value) + " m²";
        }
        return `<div class="tmp-label-wrapper ${arr_current_config.key}">${arr_current_config.label}</div><div class="tmp-value-wrapper ${arr_current_config.key}">${output_value}</div>`;
      }
      return "";
    },
    get_suffix_special(current_prop) {
      if (
        true === this.geoWerftData.price_on_request_cb &&
        parseInt(current_prop.oo_price_on_request || "") === 1
      ) {
        return "";
      }

      return this.geoWerftData.texts.currency_suffix;
    },
    mabye_get_on_request_price(current_prop) {
      if (
        true === this.geoWerftData.price_on_request_cb &&
        parseInt(current_prop.oo_price_on_request || "") === 1
      ) {
        current_prop.kaufpreis = "0";
      }
      return current_prop.kaufpreis;
    },
    get_special_list_title(object) {
      let output_title = object.objekttitel;
      if (true === this.geoWerftData.checkboxes.other_info_window_v2) {
        let additional_info_by_aquisition_type = "zum Kauf";
        if (
          object.erwerbsart.toLowerCase() === "miete" ||
          object.erwerbsart.toLowerCase() === "rent"
        ) {
          additional_info_by_aquisition_type = "zur Miete";
        }
        output_title = `${object.objekttyp} ${additional_info_by_aquisition_type} <br> ${object.plz} ${object.ort}`;
      }
      return output_title;
    },
    mw_list_get_settings_by_json(current_list_prop_obj) {
      const current_possible_json = JSON.parse(
        this.geoWerftData.texts.list_visibility_json
      );
      let custom_html_to_return = "";
      if (current_possible_json) {
        for (const key in current_possible_json) {
          if (current_possible_json.hasOwnProperty(key)) {
            const running_arr_key_value = current_possible_json[key];

            const check_for_user_status =
              running_arr_key_value["only_check_if_user_offline"] || false;
            let current_user_status = geowerftSettings.user_is_logged_in;
            if (true === geowerftSettings.user_logged_in_by_cookie) {
              current_user_status = true;
            }

            if (
              true === check_for_user_status &&
              false === current_user_status
            ) {
              if (
                (running_arr_key_value["check_meta"] &&
                  running_arr_key_value["check_meta_value"]) ||
                (running_arr_key_value["check_meta_exist"] &&
                  current_list_prop_obj[
                    running_arr_key_value["check_meta_exist"]
                  ])
              ) {
                if (
                  (
                    current_list_prop_obj[
                      running_arr_key_value["check_meta"]
                    ] || ""
                  ).toLowerCase() ===
                  running_arr_key_value["check_meta_value"].toLowerCase()
                ) {
                  // Prüfung okay, nun änderungen machen.
                  if (running_arr_key_value["change_meta"]) {
                    current_list_prop_obj[
                      running_arr_key_value["change_meta"]
                    ] = running_arr_key_value["change_meta_value"] || undefined;
                  }
                  if (running_arr_key_value["custom_html"]) {
                    custom_html_to_return += this.mw_list_replace_placeholders(
                      running_arr_key_value["custom_html"],
                      current_list_prop_obj
                    );
                  }
                }
              }
            }

            if (false === check_for_user_status) {
              if (
                (running_arr_key_value["check_meta"] &&
                  running_arr_key_value["check_meta_value"]) ||
                (running_arr_key_value["check_meta_exist"] &&
                  current_list_prop_obj[
                    running_arr_key_value["check_meta_exist"]
                  ])
              ) {
                if (
                  (
                    current_list_prop_obj[
                      running_arr_key_value["check_meta"]
                    ] || ""
                  ).toLowerCase() ===
                  running_arr_key_value["check_meta_value"].toLowerCase()
                ) {
                  // Prüfung okay, nun änderungen machen.
                  if (running_arr_key_value["change_meta"]) {
                    current_list_prop_obj[
                      running_arr_key_value["change_meta"]
                    ] = running_arr_key_value["change_meta_value"] || undefined;
                  }
                  if (running_arr_key_value["custom_html"]) {
                    custom_html_to_return += this.mw_list_replace_placeholders(
                      running_arr_key_value["custom_html"],
                      current_list_prop_obj
                    );
                  }
                }
              }
            }
          }
        }
      }

      return custom_html_to_return;
    },
    mw_list_replace_placeholders(
      template,
      data,
      { onMissing = "keep", missingValue = "" } = {}
    ) {
      // onMissing: 'keep' | 'remove' | 'default'
      return template.replace(/\{([^{}]+)\}/g, (match, key) => {
        let cleanKey = key.trim();
        let is_currency = false;
        let is_area = false;
        // Hier muss noch geschaut werden, ob Formatierungen notwendig sind.
        if (cleanKey.includes("_currency")) {
          cleanKey = cleanKey.replace("_currency", "");
          is_currency = true;
        }

        if (cleanKey.includes("_area")) {
          cleanKey = cleanKey.replace("_area", "");
          is_area = true;
        }

        let value = data.hasOwnProperty(cleanKey) ? data[cleanKey] : undefined;

        if (value === undefined) {
          if (onMissing === "remove") return "";
          if (onMissing === "default") return String(missingValue);
          // 'keep'
          return match;
        }

        if (true === is_currency) {
          value = this.get_format_price(value, data) + " €";
        }

        if (true === is_area) {
          value = this.mw_format_area(value) + " m²";
        }

        return String(value);
      });
    },
    map_get_sold_label(object) {
      let tmp_label_string = "Verkauft";
      if (object.mw_map_star_rating) {
        const tmp_star_rating_number = parseInt(object.mw_map_star_rating);
        let tmp_star_rating_string = '<div class="map-star-rating">';
        for (let i = 1; i <= tmp_star_rating_number; i++) {
          tmp_star_rating_string += "&#9733;";
        }
        tmp_star_rating_string += "</div>";
        tmp_label_string += tmp_star_rating_string;
      }
      return tmp_label_string;
    },
    check_commision(object) {
      if (
        object.aussencourtage_ja !== undefined &&
        this.geoWerftData.texts.display_text_no_buyer_comission &&
        object.aussencourtage_ja !== null &&
        object.erwerbsart &&
        (object.erwerbsart.toLowerCase() === "kauf" ||
          "buy" === object.erwerbsart.toLowerCase())
      ) {
        if (
          object.aussencourtage_ja &&
          "nein" === object.aussencourtage_ja.toLowerCase()
        ) {
          return true;
        }
      }
      return false;
    },
    render_new_badge_content(current_prop) {
      var pricing = "";
      if (
        current_prop.erwerbsart &&
        (current_prop.erwerbsart.toLowerCase() === "kauf" ||
          current_prop.erwerbsart.toLowerCase() === "buy") &&
        !isNaN(parseInt(current_prop.kaufpreis)) &&
        undefined !== current_prop.kaufpreis &&
        "" !== current_prop.kaufpreis
      ) {
        pricing =
          this.get_format_price(current_prop.kaufpreis, current_prop) +
          " " +
          this.geoWerftData.texts.currency_suffix;
      }
      if (
        current_prop.erwerbsart &&
        (current_prop.erwerbsart.toLowerCase() === "miete" ||
          current_prop.erwerbsart.toLowerCase() === "rent") &&
        !isNaN(parseInt(current_prop.nettokaltmiete)) &&
        undefined !== current_prop.nettokaltmiete &&
        "" !== current_prop.nettokaltmiete
      ) {
        pricing =
          this.get_format_price(current_prop.nettokaltmiete, current_prop) +
          " " +
          this.geoWerftData.texts.currency_suffix;
      }
      return pricing;
    },
    mw_format_list_number_output(str_number) {
      let working_number = str_number || "";
      working_number = working_number.replace(".00", "");
      working_number = working_number.replace(".", ",");
      return working_number;
    },
    mw_format_area(number) {
      if (undefined === number || "" === number) {
        return "";
      }
      var result = number;
      // replace special chars.
      result = this.replace_special_chars(result);
      // format the price.
      return new Intl.NumberFormat("de-DE", {
        style: "decimal",
      }).format(result);
    },
    get_placeholder_img_by_hp(homepage_status, img_url, prop_type) {
      if (
        homepage_status &&
        prop_type &&
        false === this.geoWerftData.interactive_filter_active
      ) {
        switch (homepage_status.toLowerCase()) {
          case "secret sale":
            if (false === this.geoWerftData.user.logged_in) {
              img_url = this.geoWerftData.image_placeholder_secret;
            }
            break;
          case "aktive marktbeobachtung":
            img_url = this.geoWerftData.image_placeholder_market_watch;
            if ("haus" === prop_type.toLowerCase()) {
              img_url = this.geoWerftData.image_placeholder_market_watch_house;
            }
            if ("wohnung" === prop_type.toLowerCase()) {
              img_url = this.geoWerftData.image_placeholder_market_watch_flat;
            }
            if ("grundstück" === prop_type.toLowerCase()) {
              img_url = this.geoWerftData.image_placeholder_market_watch_plot;
            }
            if ("" === img_url) {
              img_url = this.geoWerftData.image_placeholder_market_watch;
            }
            break;
          default:
            break;
        }
      }
      return img_url;
    },
    replace_special_chars(str_number) {
      if (str_number.substring(str_number.length - 3) === ".00") {
        str_number = str_number.substring(0, str_number.length - 3);
      }

      str_number = str_number.replace(/€/g, "");
      str_number = str_number.replace(/CHF/g, "");
      str_number = str_number.replace(/m²/g, "");

      // Variante aus der Immowerft in JS implementiert
      var num_position_comma = str_number.indexOf(",");
      var num_position_dot = str_number.indexOf(".");
      var check_number = str_number.replace(",", "|");
      if (num_position_comma > num_position_dot) {
        check_number = check_number.replace(".", "");
      }
      str_number = check_number.replace("|", ".");

      str_number = str_number.trim();
      return str_number;
    },
    get_picture_url(
      img_url,
      placeholder,
      default_img_url,
      homepage_status,
      prop_type
    ) {
      if (undefined === img_url || "" === img_url) {
        img_url = default_img_url;
      }

      if (undefined === img_url || "" === img_url) {
        img_url = placeholder;
      }

      var rgba_color = "0.4";
      if (true === this.geoWerftData.checkboxes.hide_picture_shadow) {
        rgba_color = "0";
      }

      // Hier noch mögliche Platzhalter setzen.
      img_url = this.get_placeholder_img_by_hp(
        homepage_status,
        img_url,
        prop_type
      );

      if (true === this.geoWerftData.use_img_tag_in_list) {
        return img_url;
      }

      return {
        background: [
          "-moz-linear-gradient(top, rgba(0, 0, 0, " +
            rgba_color +
            ") 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, " +
            rgba_color +
            ") 100%), url(" +
            img_url +
            ") no-repeat",
          "-webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, " +
            rgba_color +
            ")), color-stop(50%, rgba(0, 0, 0, 0)), color-stop(100%, rgba(0, 0, 0, " +
            rgba_color +
            "))), url(" +
            img_url +
            ") no-repeat",
          "-webkit-linear-gradient(top, rgba(0, 0, 0, " +
            rgba_color +
            ") 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, " +
            rgba_color +
            ") 100%), url(" +
            img_url +
            ") no-repeat",
          "-o-linear-gradient(top, rgba(0, 0, 0, " +
            rgba_color +
            ") 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, " +
            rgba_color +
            ") 100%), url(" +
            img_url +
            ") no-repeat",
          "-ms-linear-gradient(top, rgba(0, 0, 0, " +
            rgba_color +
            ") 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, " +
            rgba_color +
            ") 100%), url(" +
            img_url +
            ") no-repeat",
          "linear-gradient(to bottom, rgba(0, 0, 0, " +
            rgba_color +
            ") 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, " +
            rgba_color +
            ") 100%), url(" +
            img_url +
            ") no-repeat",
        ],
        backgroundSize: ["cover"],
      };
    },
    get_the_correct_type(current_prop) {
      let curr_type = current_prop.objektart_geowerft || "";
      if (curr_type === "") {
        curr_type = current_prop.objektart_raw;
      }
      if (
        true === this.geoWerftData.geo_display_objecttype &&
        current_prop.objekttyp
      ) {
        curr_type = current_prop.objekttyp;
      }

      // Anpassung für Custom Objektart.
      if ("" !== (current_prop.objekttyp_custom || "")) {
        const replacements = {
          etage: "etagenwohnung",
          rohdachboden: "rohdachbodenwohnung",
          hochparterre: "hochparterrenwohnung",
          dachgeschoss: "dachgeschosswohnung",
          maisonette: "maisonettewohnung",
          "loft-studio-atelier": "loft/Studio/Atelierwohnung",
          penthouse: "penthousewohnung",
          terrassen: "terrassenwohnung",
          etagenwohnung: "etagenwohnung",
          erdgeschoss: "erdgeschosswohnung",
          souterrain: "souterrainwohnung",
        };
        curr_type =
          replacements[current_prop.objekttyp_custom.toString()] ||
          current_prop.objekttyp_custom.toString();
      }

      return this.mw_capitalite_first_letter(curr_type);
    },
    mw_capitalite_first_letter(string) {
      if (string && string.length > 1) {
        string = string.charAt(0).toUpperCase() + string.slice(1);
      }
      return string;
    },
    get_active_watchlist_class(current_prop) {
      var class_name = "";

      if (true === this.current_user_can_see_watchlist_icons(current_prop)) {
        class_name = "watchlist-active";
      }

      return class_name;
    },
    current_user_can_see_watchlist_icons(objekt) {
      // Anpassung für die Merkliste.
      if (
        true === this.geoWerftData.geowerft_gtb_active &&
        false === this.geoWerftData.user.logged_in &&
        true === this.geoWerftData.geowerft_gtb_watchlist_active
      ) {
        // Wenn Gutenberg aktiv ist, die Merkliste nicht anzeigen, falls der Benutzer nicht eingeloggt ist.
        // Es gibt hier nun einen alternativen Code welcher dann in diesem Fall ausgeführt wird.
        return false;
      }
      let current_hp = "";
      let current_vermarktung = "placeholder";
      if (objekt.homepage_status) {
        current_hp = objekt.homepage_status.toLowerCase();
      }
      if (objekt.vermarktungsart) {
        current_vermarktung = objekt.vermarktungsart.toLowerCase();
      }
      let check_hp_array = this.geoWerftData.watchlist_to_hide_hp
        .toLowerCase()
        .split("|");
      let check_vermakrtung_array = this.geoWerftData.watchlist_to_hide_vermarktung
        .toLowerCase()
        .split("|");
      if (
        true === this.geoWerftData.prop_watchlist_active &&
        true === this.geoWerftData.user.logged_in &&
        false === check_hp_array.includes(current_hp) &&
        false === check_vermakrtung_array.includes(current_vermarktung)
      ) {
        return true;
      }
      return (
        true === this.geoWerftData.prop_watchlist_active &&
        true === this.geoWerftData.prop_watchlist_offline_mode &&
        false === check_hp_array.includes(current_hp) &&
        false === check_vermakrtung_array.includes(current_vermarktung)
      );
    },
    current_user_can_see_blacklist() {
      // Anpassung für die Blacklist.
      if (
        true === this.geoWerftData.user.logged_in &&
        true === this.geoWerftData.enable_blacklist
      ) {
        return true;
      }

      return false;
    },
    current_user_can_see_offline_blacklist() {
      // Anpassung für die Blacklist.
      if (
        true !== this.geoWerftData.user.logged_in &&
        true === this.geoWerftData.enable_blacklist
      ) {
        return true;
      }

      return false;
    },
    set_selected_prop_offline(dom_elm, mode) {
      // Nur ausführen wenn die Checkbox aktiv ist.
      var property_id = jQuery(dom_elm).closest(mode).attr("data-id");
      if (
        property_id &&
        true === this.geoWerftData.checkboxes.allow_prop_offline_detection
      ) {
        var that = this;
        if (confirm(this.geoWerftData.texts.prop_offline_explain_text)) {
          jQuery
            .ajax({
              url:
                rest_url + "geowerft/v1/property/" + property_id + "/offline",
              method: "PUT",
              data: {
                actionkind: this.geoWerftData.texts.prop_offline_akt_kind,
                actiontype: this.geoWerftData.texts.prop_offline_akt_type,
              },
              beforeSend: function (xhr) {
                xhr.setRequestHeader("X-WP-Nonce", wp_nonce.nonce);
              },
            })
            .done(function (response) {
              alert(that.geoWerftData.texts.prop_offline_success_text);
              setTimeout(function () {
                location.reload(true);
              }, 2000);
            });
        }
      }
    },
    get_future_extra_fields(current_prop) {
      let content = "";
      let pos_content = [];
      if (current_prop) {
        let curr_rooms = current_prop.anzahl_zimmer;
        let arr_values_fl = [
          current_prop.wohnflaeche,
          current_prop.vermietbare_flaeche,
          current_prop.grundstuecksflaeche,
          current_prop.gesamtflaeche,
        ];
        for (let key in arr_values_fl) {
          if (arr_values_fl[key]) {
            pos_content.push("Wohnfläche: " + arr_values_fl[key] + " m²");
            // Only use the first you find.
            break;
          }
        }
        if (curr_rooms) {
          pos_content.push("Zimmer: " + curr_rooms);
        }
        content = pos_content.join("<br>");
      }
      return content;
    },
    return_no_immo_in_b_text(current_mode) {
      var display_text;
      if ("map" === current_mode) {
        display_text = this.geoWerftData.texts.no_immo_in_bounds_text;
      } else {
        display_text = this.geoWerftData.texts.no_immo_in_bounds_text_list_view;
      }
      return display_text;
    },
    trigger_banner_render(index) {
      var current_width = window.innerWidth;
      if (3 === index) {
        var main_element = document.querySelectorAll("*[data-index]");
        var banner_src = this.geoWerftData.texts.geo_banner_picture_src;

        if (
          "list" === this.geoWerftData.current_map_mode &&
          "" !== this.geoWerftData.texts.geo_banner_picture_src_list
        ) {
          banner_src = this.geoWerftData.texts.geo_banner_picture_src_list;
        }
        var banner_link = this.geoWerftData.texts.geo_banner_picture_link;
        var banner_html = this.geoWerftData.texts.geo_banner_custom_html;

        // Hier die Fenstergröße Prüfen und ggf. anderes Banner anzeigen.
        if (
          current_width <=
            parseInt(this.geoWerftData.texts.banner_mobile_first_px) &&
          "" !== this.geoWerftData.texts.banner_mobile_first_link
        ) {
          banner_src = this.geoWerftData.texts.banner_mobile_first_link;
        }

        if (
          main_element[3] !== undefined &&
          ((banner_src && banner_link) || banner_html)
        ) {
          if (document.querySelector(".geo-banner")) {
            document.querySelector(".geo-banner").remove();
          }
          if (banner_src && banner_link) {
            main_element[3].insertAdjacentHTML(
              "afterend",
              '<li class="geo-banner geo-banner-wrapper"><a href="' +
                banner_link +
                '" target="_blank"><img class="geowerft-banner-img" alt="" src="' +
                banner_src +
                '"></a>'
            );
          }
          if (banner_html) {
            main_element[3].insertAdjacentHTML(
              "afterend",
              '<li class="geo-banner custom-html">' + banner_html + "</li>"
            );
          }
        }
        if (
          main_element[3] === undefined &&
          document.querySelector(".geo-banner")
        ) {
          document.querySelector(".geo-banner").remove();
        }
        geowerft_position_banner("geo-banner");
      }

      if (
        index === 11 &&
        "" !== this.geoWerftData.texts.banner_picture_src_second &&
        "" !== this.geoWerftData.texts.banner_picture_link_second
      ) {
        var main_element = document.querySelectorAll("*[data-index]");
        var banner_src = this.geoWerftData.texts.banner_picture_src_second;
        var banner_link = this.geoWerftData.texts.banner_picture_link_second;

        // Hier die Fenstergröße Prüfen und ggf. anderes Banner anzeigen.
        if (
          current_width <=
            parseInt(this.geoWerftData.texts.banner_mobile_second_px) &&
          "" !== this.geoWerftData.texts.banner_mobile_second_link
        ) {
          banner_src = this.geoWerftData.texts.banner_mobile_second_link;
        }

        if (main_element[11] !== undefined && banner_src && banner_link) {
          if (document.querySelector(".geo-banner-second")) {
            document.querySelector(".geo-banner-second").remove();
          }
          main_element[11].insertAdjacentHTML(
            "afterend",
            '<li class="geo-banner-second geo-banner-wrapper"><a href="' +
              banner_link +
              '" target="_blank"><img class="geowerft-banner-img" alt="" src="' +
              banner_src +
              '"></a>'
          );
        }
        if (
          main_element[11] === undefined &&
          document.querySelector(".geo-banner-second")
        ) {
          document.querySelector(".geo-banner-second").remove();
        }
        geowerft_position_banner("geo-banner-second");
      }
    },
    list_trigger_ajax_request(current_prop, possible_values) {
      // Ajax erst einmal nur für Aktive markbeobachtung nutzen.
      if (
        true === this.geoWerftData.user.logged_in &&
        true === this.geoWerftData.checkboxes.enable_market_watch_ajax
      ) {
        if (
          (current_prop &&
            current_prop.homepage_status &&
            "aktive marktbeobachtung" ===
              current_prop.homepage_status.toLowerCase()) ||
          (current_prop.vermarktungsart &&
            "fremdobjekt" === current_prop.vermarktungsart.toLowerCase())
        ) {
          jQuery.ajax({
            type: "POST",
            url: this.geoWerftData.texts.ajax_url,
            data: {
              action: "handle_marked_watch_click",
              current_link: current_prop.link_extern,
              current_id: current_prop.kennung,
              akt_kind: this.geoWerftData.texts.market_watch_akt_kind,
              akt_type: this.geoWerftData.texts.market_watch_akt_type,
              current_user_id: this.geoWerftData.user.current_user_id,
            },
            success: function (response) {},
          });
        }
      }
    },
    mw_display_gtb_watchlist() {
      if (
        true === this.geoWerftData.geowerft_gtb_active &&
        false === this.geoWerftData.user.logged_in &&
        true === this.geoWerftData.geowerft_gtb_watchlist_active
      ) {
        return true;
      }
      return false;
    },
    mw_display_gtb_watchlist_detailed() {
      if (
        true === this.geoWerftData.geowerft_gtb_active &&
        true === this.geoWerftData.user.logged_in &&
        true === this.geoWerftData.geowerft_gtb_watchlist_active_detailed
      ) {
        return true;
      }
      return false;
    },
    get_watchlist_detailed_current_icon(current_prop_id) {
      let add_to_detailed_watchlist_svg =
        '<svg class="mw-detailed-watchlist-icon-map mw-detailed-watchlist-icon-map-add" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v240H160v240h400v80H160Zm0-480h640v-80H160v80ZM760-80v-120H640v-80h120v-120h80v120h120v80H840v120h-80ZM160-240v-480 480Z"/></svg>';
      let remove_from_detailed_watchlist_svg =
        '<svg class="mw-detailed-watchlist-icon-map mw-detailed-watchlist-icon-map-remove" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m871-203-71-71v-206H594L434-640h366v-80H354l-80-80h526q33 0 56.5 23.5T880-720v480q0 10-2 19.5t-7 17.5ZM385-462Zm192-35Zm-211 17H160v240h446L366-480ZM818-28 686-160H160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800l80 80h-80v80h46L26-820l57-57L875-85l-57 57Z"/></svg>';
      let json_str_watch_list_detailed = this.geoWerftData
        .user_watchlist_detailed;

      if (
        true ===
        json_str_watch_list_detailed.includes(current_prop_id.toString())
      ) {
        return remove_from_detailed_watchlist_svg;
      } else {
        return add_to_detailed_watchlist_svg;
      }
    },
    check_current_watchlist_detailed_status(current_prop_id) {
      let json_str_watch_list_detailed = this.geoWerftData
        .user_watchlist_detailed;

      if (json_str_watch_list_detailed) {
        if (
          true ===
          json_str_watch_list_detailed.includes(current_prop_id.toString())
        ) {
          return "mw-detailed-watchlist-icon-wrapper mw-watchlist-detailed-remove";
        }
      }

      return "mw-detailed-watchlist-icon-wrapper mw-watchlist-detailed-add";
    },
    mw_gtb_open_login_or_register() {
      if (document.querySelector("#mw-ben-main-dialog")) {
        document.querySelector("#mw-ben-main-dialog").showModal();
      }
    },
    check_current_watchlist_status(current_prop_id) {
      var str_watch_list = this.geoWerftData.user_watchlist;

      let default_icon_class = "fa fa-star fa-2x";
      let default_icon_selected_class = "fa fa-star-o fa-2x";

      if (true === this.geoWerftData.geowerft_setting_watchlist_icon) {
        default_icon_class = "fa fa-heart fa-2x";
        default_icon_selected_class = "fa fa-heart-o fa-2x";
      }

      // Wenn Gutenberg für die Merkliste verwendet wird, muss noch einmal das Meta aufbereitet werden.
      if (
        true === this.geoWerftData.geowerft_gtb_active &&
        "" !== str_watch_list
      ) {
        let tmp_new_list = "";
        const tmp_list_from_user_meta = JSON.parse(str_watch_list);
        for (const [key, value] of Object.entries(tmp_list_from_user_meta)) {
          tmp_new_list += key + "|";
        }
        str_watch_list = tmp_new_list;
        localStorage.setItem("mw_user_prop_watchlist_v2", str_watch_list);
      }

      if (str_watch_list === "") {
        // Versuchen mit dem Localstorage zu arbeiten.
        str_watch_list = localStorage.getItem("mw_user_prop_watchlist");
        if (true === this.geoWerftData.geowerft_gtb_active) {
          str_watch_list = localStorage.getItem("mw_user_prop_watchlist_v2");
        }
      }

      if ("" !== this.geoWerftData.geowerft_setting_watchlist_icon_custom) {
        default_icon_selected_class = "";
        default_icon_class = "";
      }

      if (str_watch_list) {
        var arr_list = str_watch_list.split("|");
        if (true === arr_list.includes(current_prop_id.toString())) {
          return default_icon_class + " mw-watchlist-ico mw-watchlist-delete";
        }
      }

      return default_icon_selected_class + " mw-watchlist-ico";
    },
    check_current_blacklist_status(current_prop_id) {
      let json_str_black_list = this.geoWerftData.user_blacklist;

      if (json_str_black_list) {
        if (true === json_str_black_list.includes(current_prop_id.toString())) {
          return "mw-blacklist-icon-wrapper mw-blacklist-remove";
        }
      }

      return "mw-blacklist-icon-wrapper mw-blacklist-add";
    },
    check_current_blacklist_status_title(current_prop_id) {
      let json_str_black_list = this.geoWerftData.user_blacklist;

      if (json_str_black_list) {
        if (true === json_str_black_list.includes(current_prop_id.toString())) {
          return "Immobilie einbeziehen";
        }
      }

      return "Immobilie ausschließen";
    },
    trigger_mw_blacklist(current_prop_id, curr_click, user_id) {
      let current_method = "";
      if (
        jQuery(
          curr_click.target.closest("div.mw-blacklist-icon-wrapper")
        ).hasClass("mw-blacklist-add")
      ) {
        current_method = "POST";
      }

      if (
        jQuery(
          curr_click.target.closest("div.mw-blacklist-icon-wrapper")
        ).hasClass("mw-blacklist-remove")
      ) {
        current_method = "DELETE";
      }

      document.querySelector("#mw-ben-function-w8-loader").showModal();
      fetch(rest_url + "immowerft/v2/blacklist", {
        method: current_method,
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": wp_nonce.nonce,
        },
        body: JSON.stringify({
          post_id: current_prop_id,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          document.querySelector("#mw-ben-function-w8-loader").close();
          if ("DELETE" !== current_method) {
            if ("true" === data.blacklist_status) {
              this.geoWerftData.objects.filtered = this.geoWerftData.objects.filtered.filter(
                (obj) => obj.id !== current_prop_id
              );
            } else {
              jQuery(curr_click.target.closest("div.mw-blacklist-icon-wrapper"))
                .removeClass("mw-blacklist-add")
                .addClass("mw-blacklist-remove")
                .attr("title", "Immobilie einbeziehen");
            }
          } else {
            jQuery(curr_click.target.closest("div.mw-blacklist-icon-wrapper"))
              .removeClass("mw-blacklist-remove")
              .addClass("mw-blacklist-add")
              .attr("title", "Immobilie ausschließen");
          }
        })
        .catch((error) => {
          console.log("Fehler:", error);
        });
    },
    trigger_mw_watchlist_detailed(current_prop_id, curr_click, user_id) {
      let current_method = "";
      let add_to_detailed_watchlist_svg =
        '<svg class="mw-detailed-watchlist-icon-map mw-detailed-watchlist-icon-map-add" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v240H160v240h400v80H160Zm0-480h640v-80H160v80ZM760-80v-120H640v-80h120v-120h80v120h120v80H840v120h-80ZM160-240v-480 480Z"/></svg>';
      let remove_from_detailed_watchlist_svg =
        '<svg class="mw-detailed-watchlist-icon-map mw-detailed-watchlist-icon-map-remove" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m871-203-71-71v-206H594L434-640h366v-80H354l-80-80h526q33 0 56.5 23.5T880-720v480q0 10-2 19.5t-7 17.5ZM385-462Zm192-35Zm-211 17H160v240h446L366-480ZM818-28 686-160H160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800l80 80h-80v80h46L26-820l57-57L875-85l-57 57Z"/></svg>';
      if (
        jQuery(
          curr_click.target.closest("div.mw-detailed-watchlist-icon-wrapper")
        ).hasClass("mw-watchlist-detailed-add")
      ) {
        current_method = "POST";
      }

      if (
        jQuery(
          curr_click.target.closest("div.mw-detailed-watchlist-icon-wrapper")
        ).hasClass("mw-watchlist-detailed-remove")
      ) {
        current_method = "DELETE";
      }
      if (document.querySelector("#mw-ben-function-w8-loader")) {
        document.querySelector("#mw-ben-function-w8-loader").showModal();
      }

      fetch(rest_url + "benutzerwerft/v2/watchlist/detailed", {
        method: current_method,
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": wp_nonce.nonce,
        },
        body: JSON.stringify({
          post_id: current_prop_id,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (document.querySelector("#mw-ben-function-w8-loader")) {
            document.querySelector("#mw-ben-function-w8-loader").close();
          }
          if ("POST" === current_method) {
            jQuery(
              curr_click.target.closest(
                "div.mw-detailed-watchlist-icon-wrapper"
              )
            )
              .removeClass("mw-watchlist-detailed-add")
              .addClass("mw-watchlist-detailed-remove")
              .attr("title", "Immobilie aus der Vergleichsliste raus nehmen")
              .html(remove_from_detailed_watchlist_svg);
          } else {
            jQuery(
              curr_click.target.closest(
                "div.mw-detailed-watchlist-icon-wrapper"
              )
            )
              .removeClass("mw-watchlist-detailed-remove")
              .addClass("mw-watchlist-detailed-add")
              .attr("title", "Immobilie in die Vergleichsliste aufnehmen")
              .html(add_to_detailed_watchlist_svg);
          }
        })
        .catch((error) => {
          console.log("Fehler:", error);
        });
    },
    trigger_mw_watchlist(current_prop_id, curr_click, user_id) {
      if (!jQuery(curr_click.target).hasClass("mw-watchlist-delete")) {
        var str_watch_list = localStorage.getItem("mw_user_prop_watchlist");
        if (true === this.geoWerftData.geowerft_gtb_active) {
          str_watch_list = localStorage.getItem("mw_user_prop_watchlist_v2");
        }
        var bool_already_in_list = false;
        if (str_watch_list) {
          var arr_list = str_watch_list.split("|");
          for (var key in arr_list) {
            if (arr_list[key].toString() === current_prop_id.toString()) {
              bool_already_in_list = true;
            }
          }
        }
        var new_list = "";
        if (false === bool_already_in_list) {
          if (null === str_watch_list) {
            str_watch_list = "";
          }
          new_list = str_watch_list + "|" + current_prop_id;
          if (true === this.geoWerftData.geowerft_gtb_active) {
            localStorage.setItem("mw_user_prop_watchlist_v2", new_list);
          } else {
            localStorage.setItem("mw_user_prop_watchlist", new_list);
          }
        }
        let default_icon_class = "fa fa-star fa-2x";

        if (true === this.geoWerftData.geowerft_setting_watchlist_icon) {
          default_icon_class = "fa fa-heart fa-2x";
        }

        // Nach dem Klick direkt die Klasse setzen.
        curr_click.target.classList =
          default_icon_class + " mw_watchlist_ico mw-watchlist-delete";

        // Hier prüfen, ob alte oder neue Route verwendet werden soll.
        if (true === this.geoWerftData.geowerft_gtb_active) {
          // Gutenberg Route für die Vergleich-Liste verwenden.
          fetch(rest_url + "benutzerwerft/v2/watchlist", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-WP-Nonce": wp_nonce.nonce,
            },
            body: JSON.stringify({
              post_id: current_prop_id,
            }),
          });
        } else {
          jQuery.ajax({
            url: this.geoWerftData.texts.ajax_url,
            type: "POST",
            cache: false,
            data: {
              action: "add_prop_to_watchlist",
              new_prop_id: current_prop_id,
              current_user: user_id,
            },
            success: function (response) {},
          });
        }
      } else {
        var current_list = localStorage.getItem("mw_user_prop_watchlist");
        if (true === this.geoWerftData.geowerft_gtb_active) {
          current_list = localStorage.getItem("mw_user_prop_watchlist_v2");
        }
        var arr_list = current_list.split("|");
        for (var key in arr_list) {
          if (arr_list[key].toString() === current_prop_id.toString()) {
            arr_list.splice(key, 1);
          }
        }
        var newlist = arr_list.join("|");
        if (true === this.geoWerftData.geowerft_gtb_active) {
          localStorage.setItem("mw_user_prop_watchlist_v2", newlist);
        } else {
          localStorage.setItem("mw_user_prop_watchlist", newlist);
        }

        let default_icon_class = "fa fa-star-o fa-2x";

        if (true === this.geoWerftData.geowerft_setting_watchlist_icon) {
          default_icon_class = "fa fa-heart-o fa-2x";
        }

        // Nach dem Klick direkt die Klasse setzen.
        curr_click.target.classList = default_icon_class + " mw-watchlist-ico";

        // Hier prüfen, ob alte oder neue Route verwendet werden soll.
        if (true === this.geoWerftData.geowerft_gtb_active) {
          fetch(rest_url + "benutzerwerft/v2/watchlist", {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              "X-WP-Nonce": wp_nonce.nonce,
            },
            body: JSON.stringify({
              post_id: current_prop_id,
            }),
          });
        } else {
          jQuery.ajax({
            url: this.geoWerftData.texts.ajax_url,
            type: "POST",
            cache: false,
            data: {
              action: "mw_delete_immo_from_watch_list",
              to_delete_id: current_prop_id,
              current_user: user_id,
            },
            success: function (response) {},
          });
        }
      }
    },
    trigger_mw_watchlist_new(current_prop_id, curr_click, user_id) {
      // Normalize clicked element
      let target = curr_click && curr_click.target ? curr_click.target : null;
      let svgEl = null;

      if (target) {
        const tag = target.tagName ? target.tagName.toLowerCase() : "";
        if (tag === "svg") {
          svgEl = target;
        } else if (tag === "path") {
          const parentSvg = target.closest ? target.closest("svg") : null;
          if (parentSvg) {
            svgEl = parentSvg;
          }
        }
      }

      let method = "";
      if (svgEl && svgEl.classList.contains("watchlist-add-icon")) {
        method = "POST";
        svgEl.closest("div.mw-watchlist-remember-immo").title =
          "Immobilie nicht mehr merken";
        svgEl.classList.add("mw-watchlist-delete");
        svgEl.classList.remove("watchlist-add-icon");
      } else if (svgEl && svgEl.classList.contains("mw-watchlist-delete")) {
        method = "DELETE";
        svgEl.closest("div.mw-watchlist-remember-immo").title =
          "Immobilie merken";
        svgEl.classList.add("watchlist-add-icon");
        svgEl.classList.remove("mw-watchlist-delete");
      }
      if (document.querySelector("#mw-ben-function-w8-loader")) {
        document.querySelector("#mw-ben-function-w8-loader").showModal();
      }
      fetch(rest_url + "benutzerwerft/v2/watchlist", {
        method: method,
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": wp_nonce.nonce,
        },
        body: JSON.stringify({
          post_id: current_prop_id,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (document.querySelector("#mw-ben-function-w8-loader")) {
            document.querySelector("#mw-ben-function-w8-loader").close();
          }
        })
        .catch((error) => {
          console.log("Fehler:", error);
        });
    },
    get_new_watchlist_titel(current_prop_id) {
      var str_watch_list = this.geoWerftData.user_watchlist;
      // Wenn Gutenberg für die Merkliste verwendet wird, muss noch einmal das Meta aufbereitet werden.
      if (
        true === this.geoWerftData.geowerft_gtb_active &&
        "" !== str_watch_list
      ) {
        let tmp_new_list = "";
        const tmp_list_from_user_meta = JSON.parse(str_watch_list);
        for (const [key, value] of Object.entries(tmp_list_from_user_meta)) {
          tmp_new_list += key + "|";
        }
        str_watch_list = tmp_new_list;
        localStorage.setItem("mw_user_prop_watchlist_v2", str_watch_list);
      }

      if (str_watch_list === "") {
        // Versuchen mit dem Localstorage zu arbeiten.
        str_watch_list = localStorage.getItem("mw_user_prop_watchlist");
        if (true === this.geoWerftData.geowerft_gtb_active) {
          str_watch_list = localStorage.getItem("mw_user_prop_watchlist_v2");
        }
      }

      let current_titel = "Immobilie merken";

      if (str_watch_list) {
        var arr_list = str_watch_list.split("|");
        if (true === arr_list.includes(current_prop_id.toString())) {
          current_titel = "Immobilie nicht mehr merken";
        }
      }
      return current_titel;
    },
    get_new_watchlist_icon(current_prop_id) {
      var str_watch_list = this.geoWerftData.user_watchlist;
      // Wenn Gutenberg für die Merkliste verwendet wird, muss noch einmal das Meta aufbereitet werden.
      if (
        true === this.geoWerftData.geowerft_gtb_active &&
        "" !== str_watch_list
      ) {
        let tmp_new_list = "";
        const tmp_list_from_user_meta = JSON.parse(str_watch_list);
        for (const [key, value] of Object.entries(tmp_list_from_user_meta)) {
          tmp_new_list += key + "|";
        }
        str_watch_list = tmp_new_list;
        localStorage.setItem("mw_user_prop_watchlist_v2", str_watch_list);
      }

      if (str_watch_list === "") {
        // Versuchen mit dem Localstorage zu arbeiten.
        str_watch_list = localStorage.getItem("mw_user_prop_watchlist");
        if (true === this.geoWerftData.geowerft_gtb_active) {
          str_watch_list = localStorage.getItem("mw_user_prop_watchlist_v2");
        }
      }

      // Basierend auf dem Custom-Icon (SVG-String)
      const customSvg =
        this.geoWerftData.geowerft_setting_watchlist_icon_custom || "";

      if (str_watch_list) {
        var arr_list = str_watch_list.split("|");
        if (true === arr_list.includes(current_prop_id.toString())) {
          // Falls Objekt bereits gemerkt ist: SVG zurückgeben, aber mit Klasse "mw-watchlist-delete"
          if (typeof customSvg === "string") {
            // Ersetze alle Vorkommen der Default-Klasse durch die Delete-Klasse
            return customSvg.replace(
              /watchlist-add-icon/g,
              "mw-watchlist-delete"
            );
          }
          return customSvg;
        }
      }
      // Standard: Unverändertes SVG zurückgeben
      return customSvg;
    },
    get_correct_info_text() {
      var info_text = this.geoWerftData.texts.text_sc_info_text;
      if (info_text === "") {
        info_text = this.geoWerftData.texts.not_in_scope_text;
      }
      return info_text;
    },
    parseDate(input) {
      var format = "dd.mm.yyyy"; // default format
      var parts = input.match(/(\d+)/g),
        i = 0,
        fmt = {};
      // extract date-part indexes from the format
      format.replace(/(yyyy|dd|mm)/g, function (part) {
        fmt[part] = i++;
      });

      return new Date(
        parts[fmt["yyyy"]],
        parts[fmt["mm"]] - 1,
        parts[fmt["dd"]]
      );
    },
    send_info_to_map(current_id) {
      EventBus.$emit("geowerft_list_click", current_id);
    },
    handle_picture_click(current_prop, event) {
      if (
        (this.geoWerftData.current_map_mode === "list" &&
          true === this.geoWerftData.checkboxes.picture_click_active &&
          "h2" !== event.target.localName &&
          "div" !== event.target.localName &&
          "em" !== event.target.localName) ||
        true === this.geoWerftData.checkboxes.picture_click_always_active
      ) {
        let current_hp_status = current_prop.homepage_status;
        let current_vermakt = current_prop.vermarktungsart;
        let result = "";
        if (
          (current_hp_status === "Aktive Marktbeobachtung" ||
            current_vermakt === "Fremdobjekt") &&
          !(current_prop.link_extern || "").trim() &&
          false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active
        ) {
          result = "";
        } else if (
          (current_hp_status === "Aktive Marktbeobachtung" ||
            current_vermakt === "Fremdobjekt") &&
          true === this.geoWerftData.checkboxes.logged_in_market_watch &&
          false === this.geoWerftData.user.logged_in
        ) {
          result = this.geoWerftData.texts.market_watch_alt_link;
        } else if (
          (current_hp_status === "Aktive Marktbeobachtung" ||
            current_vermakt === "Fremdobjekt") &&
          false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active
        ) {
          result = current_prop.link_extern;
        } else if (
          true === this.geoWerftData.show_extern_link &&
          (current_prop.link_extern || "").trim() &&
          false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active
        ) {
          result = current_prop.link_extern;
        } else if (this.geoWerftData.checkboxes.other_info_window) {
          result = current_prop.link;
        } else {
          result = current_prop.link;
        }
        if (typeof result === "string" && result.trim() !== "") {
          window.open(result, "_blank");
        }
      }
      this.list_trigger_ajax_request(current_prop);
    },
    handle_custom_link_click(link) {
      window.open(link, "_blank");
    },
    get_format_price(number, current_prop) {
      if (
        true === this.geoWerftData.price_on_request_cb &&
        parseInt(current_prop.oo_price_on_request || "") === 1
      ) {
        return "Auf Anfrage";
      }
      if (undefined === number || "" === number) {
        return "";
      }
      if (this.geoWerftData.checkboxes.format_prices_cb) {
        number = number.toString().replace(",", ".");
        let val = (number / 1).toFixed(2).replace(".", ",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        number = parseInt(number);
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    set_alt_tag(current_prop) {
      let map_picture_alt = current_prop.map_picture_alt || "";
      if (map_picture_alt === "") {
        map_picture_alt = current_prop.objektart_raw || "Bild der Immobilie";
      }
      return map_picture_alt;
    },
    handle_place_view(current_prop) {
      let tmp_place = current_prop.ort || "";
      if (
        "" === tmp_place &&
        true === this.geoWerftData.checkboxes.show_geo_as_fallback
      ) {
        tmp_place = current_prop.geolage || "";
      }
      return tmp_place;
    },
    get_customizer_image_for_marker(
      currentMarkerStatus,
      display_badge_new = ""
    ) {
      let link;

      link =
        this.geoWerftData.marker_image.google_maps_marker_default +
        "/images/GooglePin.png";

      if (currentMarkerStatus === "" || currentMarkerStatus === undefined) {
        return link;
      }

      if (display_badge_new !== "") {
        return this.geoWerftData.marker_image.google_maps_marker_badge_new;
      }

      currentMarkerStatus = currentMarkerStatus.toLowerCase();

      switch (currentMarkerStatus) {
        case "online":
          if (
            this.geoWerftData.marker_image.google_maps_marker_online !== false
          ) {
            link = this.geoWerftData.marker_image.google_maps_marker_online;
          }
          break;
        case "in vorbereitung":
          if (
            this.geoWerftData.marker_image
              .google_maps_marker_in_vorbereitung !== false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_in_vorbereitung;
          }
          break;
        case "verkauft":
          if (
            this.geoWerftData.marker_image.google_maps_marker_verkauft !== false
          ) {
            link = this.geoWerftData.marker_image.google_maps_marker_verkauft;
          }
          break;
        case "referenz":
          if (
            this.geoWerftData.marker_image.google_maps_marker_referenz !== false
          ) {
            link = this.geoWerftData.marker_image.google_maps_marker_referenz;
          }
          break;
        case "secret sale":
          if (
            this.geoWerftData.marker_image.google_maps_marker_secret_sale !==
            false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_secret_sale;
          }
          break;
        case "aktive marktbeobachtung":
          if (
            this.geoWerftData.marker_image
              .google_maps_marker_marktbeobachtung !== false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_marktbeobachtung;
          }
          break;
        case "marktbeobachtung":
          if (
            this.geoWerftData.marker_image
              .google_maps_marker_marktbeobachtung !== false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_marktbeobachtung;
          }
          break;
        case "neubau":
        case "neubau stammobjekt":
        case "neubau stammobjekt referenz":
          if (
            this.geoWerftData.marker_image.google_maps_marker_neubauobjekt !==
            false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_neubauobjekt;
          }
          break;
        case "neubau objekt":
          if (
            this.geoWerftData.marker_image.google_maps_marker_neubauobjekt !==
            false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_neubauobjekt;
          }
          break;
        case "neubau referenz":
          if (
            this.geoWerftData.marker_image.google_maps_marker_neubaureferenz !==
            false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_neubaureferenz;
          }
          break;
        case "exklusiv referenz":
          if (
            this.geoWerftData.marker_image
              .google_maps_marker_exlusive_object !== false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_exlusive_object;
          }
          break;
        case "bieterverfahren":
          if (
            this.geoWerftData.marker_image.google_maps_marker_auction !== false
          ) {
            link = this.geoWerftData.marker_image.google_maps_marker_auction;
          }
          break;
        case "mietbörse":
        case "mietboerse":
          if (
            this.geoWerftData.marker_image.google_maps_marker_mietboerse !==
            false
          ) {
            link = this.geoWerftData.marker_image.google_maps_marker_mietboerse;
          }
          break;
        case "immobiliendepot":
          if (
            this.geoWerftData.marker_image
              .google_maps_marker_immobiliendepot !== false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_immobiliendepot;
          }
          break;
        default:
          link =
            this.geoWerftData.marker_image.google_maps_marker_default +
            "/images/GooglePin.png";
          break;
      }

      return link;
    },
    sanitize_title_method: function (value) {
      if (typeof value === "undefined" || value === null) {
        return "";
      }
      return value.replace(/\s+/g, "-").toLowerCase();
    },
    replaceUmlauts(inputStr) {
      const map = {
        ä: "ae",
        ö: "oe",
        ü: "ue",
        ß: "ss",
        Ä: "Ae",
        Ö: "Oe",
        Ü: "Ue",
      };

      return inputStr.replace(/[äöüßÄÖÜ]/g, function (match) {
        return map[match];
      });
    },

    get_link_extern: function (object) {
      let result = "";
      if (object.link_extern) {
        result = object.link_extern
          .replace("https://www.", "")
          .replace("https://", "")
          .split("/")[0];
      }
      return result;
    },
    get_the_title(current_prop) {
      let current_title;
      current_title = current_prop.objektart_raw;
      if (
        current_prop.vermarktungsart !== undefined &&
        current_prop.vermarktungsart !== "not_set_ver" &&
        current_prop.vermarktungsart !== ""
      ) {
        current_title = current_title + "-" + current_prop.vermarktungsart;
      }
      if (
        (current_prop.homepage_status || "").toLowerCase() === "verkauft" &&
        (current_prop.erwerbsart || "").toLowerCase() === "rent"
      ) {
        current_title = current_title + "-" + "Vermietet";
      } else {
        current_title = current_title + "-" + current_prop.homepage_status;
      }
      return this.decodeHtmlEntity(current_title);
    },
    decodeHtmlEntity(str) {
      return str.replace(/&#(\d+);/g, function (match, dec) {
        return String.fromCharCode(dec);
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/objectList.vue